import React from 'react';
import { makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRefresh } from './types';
import {
    IconLookup,
    IconDefinition,
    findIconDefinition,
} from '@fortawesome/fontawesome-svg-core';

const syncLookup: IconLookup = { prefix: 'fas', iconName: 'sync' };
const syncIconDefinition: IconDefinition = findIconDefinition(syncLookup);

const useStyles = makeStyles(() => ({
    sync: {
        fontSize: '20px',
        cursor: 'pointer',
    },
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 10,
    },
}));

export const Refresh = ({ loading, handleRefresh, ...props }: IRefresh) => {
    const classes = useStyles();

    const refreshData = () => handleRefresh();

    return (
        <div className={classes.container} {...props}>
            <FontAwesomeIcon
                className={classes.sync}
                icon={syncIconDefinition}
                spin={loading}
                onClick={loading ? undefined : refreshData}
            />
        </div>
    );
};
